<template>
  <div>
    <v-container fluid style="max-width:800px;">
      <v-container class="pa-0">
        <v-card class="noisy-back" style="margin-bottom:120px;background-color:#0086D2;">
          <v-img v-if="oripa.design" :src="require(`@/assets/img/tham_back${oripa.design}.png`)" :height="header_height">
            <v-card-actions style="position:absolute;z-index:100;">
              <v-btn to="/"><v-icon>mdi-arrow-left-thin</v-icon>戻る</v-btn>
            </v-card-actions>
            <v-chip class="tham_price white--text" color="#bf9507" label style="border:solid 2px black;">
              残<span class="ml-1 mr-1" style="font-weight:bold;font-size:16px;">{{getRestLot(oripa)}}</span> / {{getAllLot(oripa)}}<span class="ml-3" style="font-weight:bold;font-size:16px;">{{oripa.price}}</span> pt
            </v-chip>
            <div class="tham_title">
              <p>{{oripa.oripa_name}}</p>
              <!--<p class="lot">全{{ getAllLot(oripa) }}口</p>-->
            </div>
            <v-img :height="header_height" class="mx-auto" style="max-width:450px;">
              <AllThumbnail v-if="Object.keys(oripa).length" :oripa="oripa" :pattern="oripa.design"></AllThumbnail>
            </v-img>
          </v-img>
          <v-card-text class="pl-0 pr-0 pt-0">
            <v-container>
              <v-chip-group column>
                <v-chip v-if="oripa.oripa_stock && getRestLot(oripa)==0" small color="error" class="white--text" label>SOLD OUT</v-chip>
                <v-chip v-else-if="oripa.oripa_stock && getRestLot(oripa)!=0 && isSaled" small color="green" class="white--text" label>発売中</v-chip>
                <v-chip v-else-if="!isSaled" small color="black" class="white--text" label>未発売</v-chip>
                <v-chip v-if="oripa.max_draw<10" small color="pink" class="white--text" label><span>MAX{{oripa.max_draw}}回</span></v-chip>
                <v-chip small color="#bf9507" class="white--text" v-for="(hashtag,index) in oripa.hashtags?oripa.hashtags.split(','):[]" :key="index"><v-icon x-small>mdi-pound</v-icon>{{ hashtag }}</v-chip>
              </v-chip-group>
              <p v-if="oripa.detail!=''" style="border:solid 1px;background-color:white;" class="rounded pa-2 mb-0">
                <v-icon small class="pr-1">mdi-information-outline</v-icon>
                {{oripa.detail}}
              </p>
            </v-container>
            <v-container class="text-center">
              <p class="text-h5">Line Up</p>
              <div v-if="oripa.oripa_stock && oripa.oripa_stock.filter(card=>card.prize==`S`).length>0">
                <p class="prizeTitle pb-4" style="font-size:3rem;">S賞</p>
                <v-row :dense="dense_tf">
                  <v-col cols="3" sm="2" md="2" lg="2" v-for="card in oripa.oripa_stock.filter(card=>card.prize==`S`)" :key="card.card_id" >
                    <v-img class="card eevee animated" :src="card.image" ref="card_S">
                      <v-chip v-if="card.lot>1" label color="black" x-small class="px-1" style="position:absolute;top:3px;right:3px;color:white;">{{card.lot}}枚</v-chip>
                    </v-img>
                  </v-col>
                </v-row>
              </div>
              <div v-if="oripa.oripa_stock && oripa.oripa_stock.filter(card=>card.prize==`LAST`).length>0">
                <p class="prizeTitle pb-4 mt-10" style="font-size:2.125rem;">ラストワン賞</p>
                <v-row :dense="dense_tf" justify="center">
                  <v-col cols="3" sm="2" md="2" lg="2" v-for="card in oripa.oripa_stock.filter(card=>card.prize==`LAST`)" :key="card.card_id" >
                    <v-img class="card eevee animated" :src="card.image" ref="card_S">
                      <v-chip v-if="card.lot>1" label color="black" x-small class="px-1" style="position:absolute;top:3px;right:3px;color:white;">{{card.lot}}枚</v-chip>
                    </v-img>
                  </v-col>
                </v-row>
              </div>
              <div v-if="oripa.oripa_stock && oripa.oripa_stock.filter(card=>card.prize==`A`).length>0">
                <p class="prizeTitle pb-4 mt-10" style="font-size:2.125rem;">A賞</p>
                <v-row style="margin-left:5%;margin-right:5%;" :dense="dense_tf">
                  <v-col cols="3" sm="2" md="2" lg="2" v-for="card in oripa.oripa_stock.filter(card=>card.prize==`A`)" :key="card.card_id" >
                    <v-img :src="card.image">
                      <v-chip v-if="card.lot>1" label color="black" x-small class="px-1" style="position:absolute;top:3px;right:3px;color:white;">{{card.lot}}枚</v-chip>
                    </v-img>
                  </v-col>
                </v-row>
              </div>
              <div v-if="oripa.oripa_stock && oripa.oripa_stock.filter(card=>card.prize==`B`).length>0">
                <p class="prizeTitle pb-4 mt-10" style="font-size:2.125rem;">B賞</p>
                <v-row style="margin-left:5%;margin-right:5%;" :dense="dense_tf">
                  <v-col cols="3" sm="2" md="2" lg="2" v-for="card in oripa.oripa_stock.filter(card=>card.prize==`B`).slice(0,24)" :key="card.card_id" >
                    <v-img :src="card.image">
                      <!-- <v-chip v-if="card.lot>1" label color="black" x-small class="px-1" style="position:absolute;top:3px;right:3px;color:white;">{{card.lot}}枚</v-chip> -->
                    </v-img>
                  </v-col>
                </v-row>
                <p v-if="oripa.oripa_stock.filter(card=>card.prize==`B`).length>10" class="prizeTitle pt-4 pb-6" style="font-size:1.0rem;">その他多数アリ</p>
              </div>
              
              <!-- <v-card v-if="[14,15].includes(oripa.oripa_id) && [500,1000].includes(oripa.price)" class="ranking-back mt-5">
                <v-card-title class="white--text">Gacha Ranking</v-card-title>
                <v-card-subtitle class="white--text text-left pt-0 pb-1">
                  SOLD OUT時点でTOP10の方は報酬を手に入れられます。SOLD OUT後にランキングを確認してください。<br>
                  同数はガチャ時刻が早い順です。ラストワン賞もカウントされます。<br>
                  Arcaraでは2枚カードが出ることもありますので、その場合2回カウントされます。<br>
                  ただし、SOLD OUT後1週間以上経過したオリパは削除されますので報酬が受け取れなくなってしまうことにご注意ください。
                </v-card-subtitle>
                <v-card-subtitle v-if="$store.getters.userData!=null" class="white--text text-left pt-0 pb-0">あなたのID: {{ $store.getters.userData?.user_id.slice(0, 8) + '-****' }}</v-card-subtitle>
                <v-card-subtitle v-if="$store.getters.userData!=null" class="white--text text-left pt-0 pb-0">あなたのガチャ枚数: {{ rankingData.filter(item => item[`oripa_id`]==$route.params.id)[0]?.myCount }}</v-card-subtitle>
                <v-data-table v-if="$store.getters.user==null" loading loading-text="ログインするとランキングが表示されます" class="ranking-back" :style="{ 'background-color': '#004B78' }"
                  dark hide-default-footer></v-data-table>
                <v-data-table v-else :headers="rankingHeaders" :items="rankingData.filter(item => item[`oripa_id`]==$route.params.id)[0]?.ranking" item-key="user_id" class="ranking-back" :style="{ 'background-color': '#004B78' }"
                  dense dark disable-sort hide-default-footer mobile-breakpoint="0" :footer-props="{ 'disable-items-per-page': true , 'page-text':'', 'items-per-page-text':''}"
                  :items-per-page.sync="itemsPerPage" :page.sync="page">
                  <template v-slot:item="props">
                    <tr :class="getRowClass(props.item)" class="text-left">
                      <td>
                        <span v-if="getGlobalIndex(props.index)==0">{{ getGlobalIndex(props.index) + 1 }}st</span>
                        <span v-else-if="getGlobalIndex(props.index)==1">{{ getGlobalIndex(props.index) + 1 }}nd</span>
                        <span v-else-if="getGlobalIndex(props.index)==2">{{ getGlobalIndex(props.index) + 1 }}rd</span>
                        <span v-else>{{ getGlobalIndex(props.index) + 1 }}</span>
                      </td>
                      <td>{{ props.item.user_id.slice(0, 8) + '-****' }}</td>
                      <td>{{ props.item.gacha_count }}</td>
                      <td>
                        <span v-if="getGlobalIndex(props.index) < 10">{{ rewards.find(item => item["point"]==oripa.price)["reward"][getGlobalIndex(props.index)]+'pt' }}</span>
                        <span v-else>無</span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-card-actions>
                  <v-btn v-if="rankingData.filter(item => item[`oripa_id`]==$route.params.id)[0]?.receive" block solo class="white--text" color="#bf9507" disabled>報酬受取済み</v-btn>
                  <v-btn v-else block solo class="white--text" color="#bf9507" :disabled="getRestLot(oripa)!=0" @click="getReward">報酬を受け取る</v-btn>
                </v-card-actions>
              </v-card> -->
              

              <div v-if="oripa.oripa_stock && blankCards.length>0">
                <p class="prizeTitle pb-2 mt-10" style="font-size:1.5rem;">C賞</p>
                <v-row dense>
                  <v-col cols="2" sm="1" md="1" lg="1" v-for="card in blankCards" :key="card.card_id">
                    <v-img :src="card.image"></v-img>
                  </v-col>
                </v-row>
                <p class="mt-4 mb-0">こちらは一部のカードです</p>
              </div>
            </v-container>
          </v-card-text>
          <v-card-text class="white--text" style="font-size:10px;">
            <p class="mb-0">カード状態について</p>
            <p>
              中古品ですので完美品ではなく、初期傷等がある場合がございます。<br>
              激しい損傷のあるカードは封入しないよう心がけていますが、一部損傷等が見受けられるカードが混じる可能性がございます。
            </p>
            <p class="mb-0">商品の返金・交換はできません。</p>
            <p>以上ご了承いただいた上でのご購入をよろしくお願いいたします。</p>
          </v-card-text>
          <v-footer v-if="$store.getters.user==null" fixed class="oripa_footer">
            <v-container style="max-width:400px;">
              <v-btn color="black" class="mb-5" dark block rounded to="/login">ログインしてガチャる</v-btn>
              <v-btn color="#bf9507" dark block rounded to="/signup">会員登録してガチャる</v-btn>
            </v-container>
          </v-footer>
          <v-footer v-else-if="oripa.oripa_stock && getRestLot(oripa)!=0 && isSaled" fixed class="oripa_footer">
            <v-container style="max-width:600px;">
              <v-row dense v-if="getRestLot(oripa)/getAllLot(oripa)<=0.1 && 10<getRestLot(oripa) && getRestLot(oripa)<200">
                <v-col>
                  <v-card @click="gacha(getRestLot(oripa))" color="#bf9507" class="rounded-lg" :disabled="oripa.oripa_type==1&&oripa.max_draw<10">
                    <v-card-text class="pa-2">
                      <p class="gacha_text white--text text-center mb-1">すべて<span style="font-size:12px;">ガチャる</span></p>
                      <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">最大{{oripa.price*getRestLot(oripa)}}pt</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  <v-card @click="gacha(10)" color="#bf9507" class="rounded-lg" :disabled="oripa.oripa_type==1&&oripa.max_draw<10">
                    <v-card-text class="pa-2" v-if="10<=getRestLot(oripa)">
                      <p class="gacha_text white--text text-center mb-1">10連<span style="font-size:12px;">ガチャる</span></p>
                      <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">{{oripa.price*10}}pt</v-btn>
                    </v-card-text>
                    <v-card-text class="pa-2" v-else>
                      <p class="gacha_text white--text text-center mb-1">すべて<span style="font-size:12px;">ガチャる</span></p>
                      <v-btn :disabled="isDisabled" color="pink accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">最大{{oripa.price*getRestLot(oripa)}}pt</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card @click="gacha(1)" color="#bf9507" class="rounded-lg">
                    <v-card-text class="pa-2">
                      <p class="gacha_text white--text text-center mb-1">1回<span style="font-size:12px;">ガチャる</span></p>
                      <v-btn :disabled="isDisabled" color="deep-purple accent-4" height="20" class="white--text" small depressed block rounded style="text-transform: none">{{oripa.price}}pt</v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-footer>
        </v-card>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from '../store'
import Api from '@/modules/api'
import Utils from '@/modules/utils'
import AllThumbnail from '@/components/AllThumbnail.vue'

export default {
  name: 'Oripa',
  components: {
    AllThumbnail,
  },
  data(){
    return{
      id: null,
      oripa: {},
      rewards: [
        {point: 500, reward: [5000,1000,500,500,500,500,500,500,500,500]},
        {point: 1000, reward: [5000,1000,500,500,500,500,500,500,500,500]}
      ],
      itemsPerPage: 10,
      page: 1,
      rankingHeaders: [
        {text:'順位', value:'rank'},
        {text:'ID', value:'user_id'},
        {text:'枚数', value:'gacha_count'},
        {text:'報酬', value:'reward'},
      ],
      image: "",
      blankCards: [],
      cards_gacha: [],
      isDisabled: false,
      dialog_prize:false,
      dialog_prize_B: false,
      dialog_prize_C: false,
    }
  },
  computed: {
    header_height(){
      switch(this.$vuetify.breakpoint.name){
        case 'xs': return 250;
        default : return 250;
      }
    },
    dense_tf(){
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true;
        default : return false;
      }
    },
    isSaled(){
      const now = new Date()
      console.log("now: ",now)
      if(Object.keys(this.oripa).length){
        const sale_ts = this.oripa.sale_ts
        console.log("oripa: ",this.oripa)
        console.log("sale_ts: ",sale_ts)
        const sale_ts_date = sale_ts.split('T')[0].split('-')
        const sale_ts_time = sale_ts.split('T')[1].split(':')
        const saleTime = new Date(Number(sale_ts_date[0]),Number(sale_ts_date[1])-1,Number(sale_ts_date[2]),Number(sale_ts_time[0]),Number(sale_ts_time[1]),Number(sale_ts_time[2]))
        console.log("saleTime: ",saleTime)
        if(saleTime < now){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    rankingData(){
      if(store.getters.ranking == null) return []
      return store.getters.ranking
    },
  },
  mounted: function(){
    this.id = this.$route.params.id
    let oripas = this.$store.getters.oripas
    if(oripas == null){
      Api.getOripas().then(res => {
        this.getOripa(res["data"])
      })
    }else{
      this.getOripa(oripas)
    }
    // if(this.$store.getters.user != null){
    //   Api.getRankingOripa(this.$route.params.id, this.$store.getters.userData.user_id).then(res => {
    //     this.ranking = res["data"]
    //     console.log("ranking: ",this.ranking)
    //   })
    // }
  },
  methods: {
    ...mapActions(["openSnackbar", "closeSnackbar"]),
    getRowClass(item){
      console.log("userData: ",this.$store.getters.userData)
      return item.user_id == this.$store.getters.userData?.user_id ? "highlighted-row" : ""
    },
    getRestLot: function(oripa){
      return oripa['all_rest_lot']
      // const oripa_stock = oripa["oripa_stock"]
      // return oripa_stock.filter(card=>card["prize"]!='LAST').map(el => el["rest_lot"]).reduce(function(sum, element){return sum + element;}, 0);
    },
    getAllLot: function(oripa){
      return oripa['all_lot']
      // const oripa_stock = oripa["oripa_stock"]
      // return oripa_stock.filter(card=>card["prize"]!='LAST').map(el => el["lot"]).reduce(function(sum, element){return sum + element;}, 0);
    },
    getGlobalIndex(index) {
      return index + this.itemsPerPage * (this.page-1)
    },
    getOripa: function(oripas){
      for(let i=0;i<oripas.length;i++){
        if(oripas[i].oripa_id == this.id){
          this.oripa = oripas[i]
          console.log(this.oripa)
          if(store.getters.allBlankCards == null){
            Api.getCardsStockBlank().then(res => {
              this.getBlankCards(this.oripa)
            })
          }else{
            this.getBlankCards(this.oripa)
          }
        }
      }
    },
    getBlankCards: function(oripa){
      console.log("=====getBlankCards=====")
      let oripa_stock = oripa.oripa_stock
      let blankCards = []
      let prizeC = []
      for(let i=0;i<oripa_stock.length;i++){
        if(oripa_stock[i]["return_point"] != null){
          if(oripa_stock[i]["prize"] == 'C'){
            prizeC.push(oripa_stock[i]["return_point"])
          }
        }
      }
      prizeC = Array.from(new Set(prizeC)).sort((a, b) => b - a)
      console.log(prizeC)
      //random値をmin~maxでn個取得
      const pickN = (min, max, n) => {
        const list = new Array(max-min+1).fill().map((_, i) => i + min);
        const ret = [];
        while(n--) {
          const rand = Math.floor(Math.random() * (list.length + 1)) - 1;
          ret.push(...list.splice(rand, 1))
        }
        return ret;
      }
      let jsonCardData, jsonCardDataC=[], randoms;
      for(let i=0;i<prizeC.length;i++){
        jsonCardData = store.getters.allBlankCards.find(element => element.return_point === prizeC[i]).cards
        jsonCardDataC.push(jsonCardData)
        randoms = pickN(0,jsonCardDataC[i].length-1, 24)
        blankCards = blankCards.concat(randoms.map(item=>jsonCardDataC[i][item]))
      }
      console.log(blankCards)
      this.blankCards = blankCards
    },
    gacha: function(num){
      this.isDisabled = true
      if(this.oripa.oripa_type == 1 && this.oripa.max_draw == 1){
        if(store.getters.userData.tell_number == ''){
          this.openSnackbar("📞 電話番号認証をしてください.")
          this.$router.push('/profile')
          return
        }
      }
      Api.postOripaGacha(this.$route.params.id,num).then(res => {
        Api.getUser()
        Api.getOripas()
        Api.getRankingOripaAll()
        this.$router.push({
          name: 'lottery',
          params: {
            num: num,
            results: res["data"]
          }
        })
      }).catch((err) => {
        // console.log(err)
        if(err.response?.status == 500){
          if(err.response.data == 'GachaError'){
            this.openSnackbar("🙇 ガチャに失敗しました...")
          }else if(err.response.data == 'NotEnoughPoints'){
            this.openSnackbar("😱 ポイントが足りません...")
            this.$router.push('/points')
          }else if(err.response.data == 'SOLDOUT'){
            this.openSnackbar("🥺 SOLD OUT...")
            Api.getOripas().then(()=>{this.$router.push('/')})
          }else if(err.response.data == 'NotExist'){
            this.openSnackbar("🫣 このオリパはまだ販売されていません...")
          }else if(err.response.data == 'AlreadyDraw'){
            this.openSnackbar("😣 ガチャに失敗しました...")
          }else if(err.response.data == 'More'){
            this.openSnackbar("🤔 ガチャに失敗しました...")
          }else{
            this.openSnackbar("ガチャ中に何らかのエラーが発生しました.運営に問い合わせてください.")  
          }
        }else{
          this.openSnackbar("ガチャ中に何らかのエラーが発生しました.運営に問い合わせてください.")
        }
      }).finally(() => {
        setTimeout(() => {
          this.isDisabled = false
        },2000)
      })
    },
    card_image: function(card_id) {
      return "https://www.pokemon-card.com/assets/images/card_images/large/"+card_id+".jpg"
    },
    getReward: function(){
      Api.postRankingOripa(this.$route.params.id).then(res => {
        const reward = res["data"]
        this.openSnackbar("🎉 ランキング報酬を受け取りました！(+"+reward+"pt)")
        Api.getUser()
      }).catch((err) => {
        console.log(err)
        if(err.response?.status == 500){
          if(err.response.data == 'NotSale'){
            this.openSnackbar("🫣 このオリパは公開されていません...")
          }else if(err.response.data == 'NotNormalGacha'){
            this.openSnackbar("🫣 特殊なガチャです")
          }else if(err.response.data == 'NotPrice'){
            this.openSnackbar("🫣 このガチャにランキング報酬はありません")
          }else if(err.response.data == 'NotSoldout'){
            this.openSnackbar("🫣 報酬はSOLD OUT後に受け取れます")
          }else if(err.response.data == 'AlreadyGet'){
            this.openSnackbar("😣 既に受け取っています...")
          }else if(err.response.data == 'NotRanker'){
            this.openSnackbar("😣 ランキングTop10圏外です...")
          }
        }else{
          this.openSnackbar("何らかのエラーが発生しました")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/holo.scss';
@import url(https://fonts.googleapis.com/earlyaccess/notosansjp.css);
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap');

.back {
background-color:rgb(181,225,239);
background-image:url("@/assets/img/bubble.svg");
background-repeat:repeat;
}

.tham_title {
  position:absolute;
  background: linear-gradient(to top, rgba(225, 225, 225, 0.85),transparent);
  z-index:10;
  width:100%;
  bottom:0;
  padding-left:30px;
  padding-top:30px;
  margin-bottom:0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-size:25px;
  color:white;
  font-weight: bold;
  /*font-family: 'Reggae One', cursive;*/
  font-family: 'RocknRoll One', sans-serif;
  text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;
}
.lot {
  font-size:15px;
}

/*.tilt_card {*/
/*  position : absolute;*/
/*  top : 50%;*/
/*  left : 50%;*/
/*  transform : translate(-50%,-50%);*/
/*  width : 190px;*/
/*  height : 265px;*/
/*  .tilt_card__container {*/
/*    width : 100%;*/
/*    height : 100%;*/
/*    -webkit-perspective: 1000px;*/
/*    perspective: 1000px;*/
/*    transform : rotate(-30deg);*/
/*    transition : transform .4s ease-out;*/
/*  }*/
/*}*/

/*.tilt_card__front,.tilt_card__back {*/
/*  z-index: 0;//overflow:hidden doesn't works transformed elem*/
/*  outline: 1px solid transparent;//firefox anti-jag*/
/*  position : absolute;*/
/*  top : 0;*/
/*  left : 0;*/
/*  width : 100%;*/
/*  height : 100%;*/
/*  border-radius : 3px;*/
/*  overflow : hidden;*/
/*  -webkit-backface-visibility: hidden;*/
/*  backface-visibility: hidden;*/
/*  transition : transform .4s ease-out;*/
/*}*/

/*.tilt_card__front {*/
/*  background : #fff;*/
/*  background-size:cover;*/
/*  background-image: url(../assets/img/pokeka_back.jpeg);*/
  /*background-image: url("https://www.pokemon-card.com/assets/images/card_images/large/S12a/042262_P_PARASU.jpg");*/
  /*background-image: var(--card-front);*/
/*}*/

/*.tilt_card__back {*/
/*  padding : 1em;*/
/*  color : #f3f3f3;*/
/*  background : #333;*/
/*  background-size:cover;*/
  /*background-image: url(../assets/img/pokeka_back.jpeg);*/
/*  transform : rotateY(180deg);*/
/*}*/

/*.flip {*/
/*  .tilt_card__front{*/
/*    transform : rotateY(-180deg);*/
/*  }*/
/*  .tilt_card__back{*/
/*    transform : rotateY(0);*/
/*  }*/
/*  &.rotate {*/
/*    transform : rotate(0) translateY(40px);*/
/*  }*/
/*}*/

/*.tilt_card__shadow {*/
/*  position : absolute;*/
/*  bottom : -15%;*/
/*  left : 22%;*/
/*  width : 80px;*/
/*  height : 20px;*/
/*  border-radius : 50%;*/
/*  background : #cacaca;*/
/*  transition : transform .5s;*/
/*  &.expand {*/
/*    transform : scaleX(2.8) translate(5px,10px);*/
/*    -webkit-filter: blur(0);//mac safari? anti-blurry*/
/*  }*/
/*}*/
.font_rockn {
  font-family: 'RocknRoll One', sans-serif;
}
.oripa_title {
  position:absolute;
  background: linear-gradient(to top, rgba(225, 225, 225, 1),transparent);
  z-index:10;
  width:100%;
  bottom:0;
  padding-left:30px;
  padding-top:30px;
  margin-bottom:0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-size:25px;
  color:white;
  font-weight: bold;
  font-family: 'RocknRoll One', sans-serif;
  text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;
}
.tham_price {
  position:absolute;
  z-index:10;
  top:10px;
  right:10px;
  /*font-weight:bold;*/
}
.oripa_lot {
  font-size:15px;
}
.oripa_footer {
  background: linear-gradient(to top, rgba(150, 150, 150, 0.85),transparent);
  padding:6px;
  transform: translate3d(0px, 0px, 1000px);
}
.prizeTitle {
  color:white;
  font-weight: bold;
  font-family: 'RocknRoll One', sans-serif;
  text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;
}
.gacha_text{
  font-size:18px;
  font-weight: bold;
  font-family: 'RocknRoll One', sans-serif;
  /*text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;*/
}


.card-container {
  -webkit-perspective: 1000;
}
/*.card-container:hover .card-item {*/
/*  -webkit-transform: rotateY(180deg);*/
/*}*/
/*.card-container:hover .card-front {*/
/*  z-index: 1;*/
/*}*/
/*.card-container:hover .card-back {*/
/*  z-index: 2;*/
/*}*/
.card-item {
  position: relative;
  -webkit-transform-style: preserve-3d;
  -webkit-transition: -webkit-transform 0.4s ease-in-out;
}
.card-front {
  overflow:hidden;
  position: relative;
  z-index: 2;
  -webkit-backface-visibility: hidden;
}
.card-back {
  position: absolute;
  top: 0;
  left: 0;
  width : 100%;
  height : 100%;
  z-index: 1;
  -webkit-backface-visibility: hidden;
  -webkit-transform: rotateY(180deg);
}
.flip {
  .card-front{
    transform : rotateY(-180deg);
    z-index: 1;
  }
  .card-back{
    transform : rotateY(0);
    z-index: 2;
  }
}
.shiny:after {
  position: absolute;
  top: -200%;
  left: -150%;
  content: "";
  height: 500%;
  width: 70px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6) 40%, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
  transform: rotate(60deg);
  animation: 3s shine infinite linear;
}
@keyframes shine {
  0% {
    left: -100%;
  }
  80% {
    left: 150%;
  }
  99.9%,to {
    left: 200%;
  }
}

.cardPos {
  position: absolute;
}
/*.flip_front {*/
/*  transform : rotateY(180deg);*/
/*  z-index: 1;*/
/*}*/
/*.flip_back {*/
/*  transform : rotateY(0);*/
/*  z-index: 2;*/
/*}*/
.card_overlay {
  position:absolute;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.85),transparent);
  z-index:10;
  width:100%;
  text-align:center;
  bottom:0;
  margin-bottom:0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-size:12px;
  color:white;
  font-weight: bold;
  /*font-family: 'Reggae One', cursive;*/
  font-family: 'Noto Sans JP', sans-serif;
  text-shadow: 2px  2px 3px black,-2px  2px 3px black,2px -2px 3px black,-2px -2px 3px black;
}

.noisy-back {
  min-height: 100vh;
  background-color:#004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
}
.ranking-back {
  background-color: #004B78;
  background-image: url(data:image/png;base64,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);  
  background-repeat: repeat;
}
.highlighted-row {
  background-color: #bf9507;
}
</style>